import type { UserEntity } from '@/features/currentUser/domain/entities/UserEntity'
import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'

export class DriverBlockEntity {
  id?: string
  driverId?: number
  driver?: DriverEntity
  blockedAt?: string
  unblockedAt?: string | null
  blockedByUserId?: string | null
  blockedByUser?: UserEntity | null
  blockedByUserDisplayName?: string
}
